'use client'

import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
  Icon,
  Typography,
} from '@repo/ui/components'
import { useState } from 'react'
import { useTranslate } from '../../hooks'
import type { ShareModalProps } from './share-modal.types'

export const ShareModal = ({ url, text, children }: ShareModalProps) => {
  const [open, setOpen] = useState(false)
  const { t } = useTranslate()

  const handleShare = (platform: string) => {
    switch (platform) {
      case 'telegram':
        window.open(
          `https://t.me/share/url?url=${encodeURIComponent(url)}&text=${encodeURIComponent(text)}`,
        )
        break
      case 'whatsapp':
        window.open(`https://wa.me/?text=${encodeURIComponent(text)}`)
        break
      case 'twitter':
        window.open(
          `https://x.com/intent/tweet?text=${encodeURIComponent(text)}`,
        )
        break
      case 'instagram':
        // Instagram doesn't have direct sharing URL, so we'll use native share
        if (navigator.share) {
          navigator
            .share({
              title: text,
              // url: url,
            })
            .catch(() => {
              // Fallback if share fails
            })
        }
        break
    }
    setOpen(false)
  }

  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogTrigger className='flex'>
        <>{children}</>
      </DialogTrigger>
      <DialogContent className='w-full sm:max-w-[450px]'>
        <DialogHeader className='flex flex-col gap-2xs'>
          <DialogTitle className='text-center mb-md'>
            <Typography
              size='md'
              color='text-neutral-surface-100'
              weight='bold'
            >
              {t('referralProject_shareOn_description')}
            </Typography>
          </DialogTitle>
        </DialogHeader>
        <div className='flex justify-center gap-xs px-md pb-md'>
          <button
            onClick={() => handleShare('whatsapp')}
            className='w-8 h-8 bg-neutral-surface-5 backdrop-blur-sm rounded-full flex items-center justify-center hover:bg-neutral-surface-60 transition-colors'
          >
            <Icon
              name='WhatsappFill'
              size='xs'
              color='fill-neutral-surface-100'
            />
          </button>

          <button
            onClick={() => handleShare('telegram')}
            className='w-8 h-8 bg-neutral-surface-5 backdrop-blur-sm rounded-full flex items-center justify-center hover:bg-neutral-surface-60 transition-colors'
          >
            <Icon
              name='TelegramFill'
              size='xs'
              color='fill-neutral-surface-100'
            />
          </button>
          <button
            onClick={() => handleShare('twitter')}
            className='w-8 h-8 bg-neutral-surface-5 backdrop-blur-sm rounded-full flex items-center justify-center hover:bg-neutral-surface-60 transition-colors'
          >
            <Icon name='X' size='xs' color='fill-neutral-surface-100' />
          </button>
          <button
            onClick={() => handleShare('instagram')}
            className='w-8 h-8 bg-neutral-surface-5 backdrop-blur-sm rounded-full flex items-center justify-center hover:bg-neutral-surface-60 transition-colors'
          >
            <Icon
              name='ShareAndroid'
              size='xs'
              color='fill-neutral-surface-100'
            />
          </button>
        </div>
      </DialogContent>
    </Dialog>
  )
}
